import React, { Component } from 'react'
import { Form, Card, Row, Col, Divider, message } from 'antd'
import styled from 'styled-components'
import { BgColorsOutlined } from '@ant-design/icons'
import { getAdditionalCss, setAdditionalCss } from '../../services/apiServices'
import RowLayout from '../../commons/RowLayout/RowLayout'
import CodeEditor from '../../commons/Editor/CodeEditor'
import AvailableClasses from './AvailableClasses'
import LoadingModal from '../../commons/Modal/Loading'
import SaveButton from '../../commons/Button/SaveButton'

const Container = styled(Card)``

class AdditionalCss extends Component {
    state = {
        isLoading: false,
        code: ''
    }

    componentDidMount() {
        this.getAdditionalCss()
    }

    onFinish() {
        this.setAdditionalCss()
    }

    onChangeCode(code) {
        this.setState({ code })
    }

    async getAdditionalCss() {
        this.setState({ isLoading: true })
        try {
            let code = await getAdditionalCss()
            this.setState({
                isLoading: false,
                code
            })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setAdditionalCss() {
        this.setState({ isLoading: true })
        try {
            await setAdditionalCss({
                body: {
                    code: this.state.code
                }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    render() {
        let { T, langSlug } = this.props

        return (
            <Form onFinish={this.onFinish.bind(this)}>
                <Container
                    title={
                        <span className="text-xl">
                            <BgColorsOutlined /> {T('ADDITIONAL_CSS')}
                        </span>
                    }>
                    <RowLayout title={T('CODE')}>
                        <Form.Item>
                            <CodeEditor
                                language="css"
                                value={this.state.code}
                                onChange={this.onChangeCode.bind(this)}
                            />
                        </Form.Item>
                    </RowLayout>

                    <Divider />

                    <Row justify="center">
                        <Col span={16} style={{ marginBottom: 24 }}>
                            <AvailableClasses T={T} langSlug={langSlug} />
                        </Col>
                    </Row>

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
                <SaveButton T={T} />
            </Form>
        )
    }
}

export default AdditionalCss
